interface IRecaptchaResponse {
    'g-recaptcha-response': string;
}

declare global {
    interface Window {
        grecaptchaSiteKey?: string;
    }
}

export const setCaptchaToken = async (data?: any): Promise<IRecaptchaResponse> => {
    return new Promise((resolve, reject) => {
        if (grecaptcha) {
            try {
                grecaptcha.ready(() => {
                    if (grecaptcha && window.grecaptchaSiteKey) {
                        void grecaptcha.execute(window.grecaptchaSiteKey, { action: 'submit' }).then((token) => {
                            if (data) {
                                Object.assign(data, { 'g-recaptcha-response': token });
                            }

                            resolve({ 'g-recaptcha-response': token });
                        });
                    } else {
                        reject();
                    }
                });
            } catch (e) {
                reject();
            }
        } else {
            // recaptcha is not enabled, resolve to an empty token
            resolve({ 'g-recaptcha-response': '' });
        }
    });
};

export const getCaptchaToken = async (): Promise<string> => {
    return new Promise((resolve, reject) => {
        if (grecaptcha) {
            try {
                grecaptcha.ready(() => {
                    if (grecaptcha && window.grecaptchaSiteKey) {
                        void grecaptcha.execute(window.grecaptchaSiteKey, { action: 'submit' }).then((token) => {
                            resolve(token);
                        });
                    } else {
                        reject();
                    }
                });
            } catch (e) {
                reject();
            }
        } else {
            // recaptcha is not enabled, resolve to an empty token
            resolve('');
        }
    });
};
